import React from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import classes from "./ErrorPage.module.css";
import Navbar from "../../Components/Navbar.js";
import FooterComp from "../../Components/FooterComp/FooterComp.js";
import AttributionsComp from "../../Components/AttributionsComp.js";

function ErrorPage() {
  const error = useRouteError();
  console.error("Route error:", error);
  const navigate = useNavigate();

  return (
    <bdo dir="rtl">
      <div className={classes.errorContainer}>
        <Navbar />
        <main className={classes.mainContent}>
          <div className={classes.errorContent}>
            <h1 className={classes.errorCode}>404</h1>
            <h2 className={classes.errorTitle}>הדף לא נמצא</h2>
            <p className={classes.errorDescription}>
              סליחה, נראה שהדף שחיפשת לא קיים או הועבר למקום אחר.
            </p>
            <div className={classes.buttonContainer}>
              <button className={classes.btnHome} onClick={() => navigate("/")}>
                חזור לדף הבית
              </button>
              <button
                className={classes.btnOrders}
                onClick={() => navigate("/orders")}
              >
                עבור לעמוד ההזמנות
              </button>
            </div>
          </div>
        </main>
        <footer>
          <FooterComp />
          <AttributionsComp />
        </footer>
      </div>
    </bdo>
  );
}

export default ErrorPage;
